import { FieldObjectType } from 'module/api/field/types';
import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { ActionBar } from 'module/ui/components/molecules/action-bar';
import { HeaderWithIconTitle } from 'module/ui/components/molecules/page/page';
import { Argon as ArgonTemplate } from 'module/ui/components/templates/argon';
import { Content } from 'module/ui/components/templates/argon/components';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@rocketlane/ui';
import { useGetAllMeetingFieldsQuery } from 'queries/fields';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SignalFieldsList } from 'components/organisms/signal-fields/list';
import { ManageFieldDrawer } from 'components/organisms/signal-fields/manage-field-drawer';
import { useManageFieldDrawerState } from 'components/organisms/signal-fields/manage-field-state';

const Argon = styled(ArgonTemplate)`
  ${Content} {
    border: none;
  }
  ${ActionBar} {
    box-shadow: none;
  }
`;

export const MeetingFieldsPage = () => {
  const title = useTranslation('meeting_fields');
  const { data: meetingFields, isLoading: isMeetingFieldsLoading } =
    useGetAllMeetingFieldsQuery();
  const {
    drawerState,
    closeDrawer,
    openDrawerInCreateMode,
    openDrawerInEditMode,
  } = useManageFieldDrawerState();

  return (
    <Argon
      documentTitle={title}
      title={
        <HeaderWithIconTitle
          icon={<FontAwesomeIcon icon={faCalendar} size={20} />}
          title={title}
        />
      }
      description={
        <FormattedMessage id="settings.meeting_fields.description" />
      }
      actions={
        isMeetingFieldsLoading
          ? {}
          : {
              secondary: (
                <Button
                  leftIcon={<FontAwesomeIcon icon={faPlus} />}
                  variant="primary"
                  onClick={openDrawerInCreateMode}
                >
                  <FormattedMessage id="settings.meeting_fields.create_field" />
                </Button>
              ),
            }
      }
      content={
        isMeetingFieldsLoading ? (
          <PageLoading />
        ) : (
          <>
            <SignalFieldsList
              fields={meetingFields ?? []}
              onEdit={openDrawerInEditMode}
            />
            <ManageFieldDrawer
              onClose={closeDrawer}
              visible={drawerState.visible}
              field={drawerState.field}
              fieldObjectType={FieldObjectType.Meeting}
            />
          </>
        )
      }
    ></Argon>
  );
};
